import BriefingDetails from './components/BriefingDetails';


export default BriefingDetails;
